<template>
  <div class="filter-parent__loading">
    <div class="skeleton-loader" style="height: 3.36em" />
  </div>
</template>

<script>
export default {
  name: 'MultiselectFilterLoader',
};
</script>
